import { isUndefined } from "lodash";
import { Duration } from "luxon";

export const getFormattedTime = (seconds?: number): string => {
	if (isUndefined(seconds)) return "";

	const duration = Duration.fromObject({ seconds });
	return getFormattedDuration(duration);
};

export const getFormattedDuration = (duration: Duration): string => {
	const currentTime = duration.shiftTo("hours", "minutes", "seconds").toObject();

	let currentDuration = "";

	if (currentTime.hours && currentTime.hours > 0) {
		currentDuration = `${currentTime.hours} h`;
	}
	if (currentTime.minutes && currentTime.minutes > 0) {
		if (currentDuration !== "") currentDuration += " ";
		currentDuration += `${currentTime.minutes} m`;
	}
	if (currentDuration === "" && currentTime.seconds && currentTime.seconds > 0) {
		currentDuration += `1 m`;
	}

	return currentDuration;
};

export const convertUTCToLocalDate = (date: Date | number) => {
	if (date) {
		const newDate = new Date(date);
		return new Date(newDate.getUTCFullYear(), newDate.getUTCMonth(), newDate.getUTCDate());
	}
};

export const convertLocalToUTCDate = (date: Date | number) => {
	if (date) {
		const newDate = new Date(date);
		return new Date(Date.UTC(newDate.getFullYear(), newDate.getMonth(), newDate.getDate()));
	}
};

export const getTimezoneOffset = (uiFormat?: boolean): string | number => {
	let offset = new Date().getTimezoneOffset();
	if (uiFormat) {
		function convertTimezone(timezone: number) {
			return (timezone < 10 ? "0" : "") + timezone;
		}
		const sign = offset <= 0 ? "+" : "-";
		offset = Math.abs(offset);
		return `(GMT${sign}${convertTimezone((offset / 60) | 0)}:${convertTimezone(offset % 60)})`;
	}
	return offset / 60;
};

export const formatCourseDuration = (minutes: number): string => {
	const duration = Duration.fromObject({ minutes }).shiftTo("hours", "minutes").toObject();

	const parts: string[] = [];

	if (duration.hours && duration.hours > 0) {
		parts.push(`${duration.hours} h`);
	}

	if (duration.minutes && duration.minutes > 0) {
		parts.push(`${duration.minutes} m`);
	}

	return parts.join(" ");
};
